import { render } from "./UiInput.vue?vue&type=template&id=5a4a08fa&scoped=true&ts=true"
import script from "./UiInput.vue?vue&type=script&lang=ts"
export * from "./UiInput.vue?vue&type=script&lang=ts"

import "./UiInput.vue?vue&type=style&index=0&id=5a4a08fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4a08fa"]])

export default __exports__